import EDSection from "dom/elements/EDSection.js"
import EDDiv from "dom/elements/EDDiv.js"
import Head from "../Head/Head.js"
import Analytics from "../Analytics/Analytics"
import Spinner from "../Spinner/Spinner"
import PopUp from "../PopUp/PopUp"
import APIUser from "../APIClientV2/APIUser.js"

export default class App extends EDSection {

    async autoReload() {
        console.log("autoReload")
        const reload = await this.router.newVersion()

        if (reload) {
            window.location.reload()
        }
    }

    render() {

        this.analytics.load().then(() => {

            super.render()
            this.analytics.event("app_init")
            this.router.go(
                window.location.href
            ).then(() => {

                const apiUser = new APIUser({
                    jwtKey: this.config.origin.apiClient.auth.jwtKey
                })
            })

        })
    }

    show(pModule) {

        this.appBody.children.unrender()
        this.appBody.children.append(pModule)
    }

    setOrigin() {

        const origin = this.config.origins[
            window.location.origin
        ]

        this.config.origin = typeof origin === "undefined" ?
            this.config.origins.default :
            origin

        this.analytics = new Analytics(
            this.config.origin.analytics
        )
    }

    getRouter(pClass) {
        return new pClass({
            onOpen: (pModule) => {
                this.show(pModule)
            },
            config: this.config
        })
    }

    buildStructure() {
        this.children.append([
            new Spinner({
                spinnerId: "main"
            }),
            new PopUp({}),
            new EDDiv({
                class: "ed-app-body",
                store: (pEl) => {
                    this.appBody = pEl
                }
            })
        ])
    }

    setFavIcon(pURL) {
        Head.setFavIcon(pURL)
    }

    constructor(p) {

        super(p)
        this.classList.add("ed-app")
        this.version = p.version
        this.config = p.config
        this.setOrigin()
        this.router = this.getRouter(
            p.router
        )
        this.buildStructure()

        if(this.config.origin.isDevEnv) {
            return
        }
        
        if (this.config.autoUpdate >= 5000) {
            this.updateInterval = setInterval(
                () => {
                    this.autoReload()
                },
                this.config.autoUpdate
            )
        }
    }
}